var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJ1772(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "J1772") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-IOS",
    stroke: "none",
    strokeWidth: 1,
    fill: "#6D6E71",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home/Search-Copy",
    transform: "translate(-100.000000, -396.000000)",
    stroke: "#020303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(36.000000, 373.488281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "J1772",
    transform: "translate(65.000000, 23.511719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4,21.2 C42.4,32.908 32.909,42.4 21.2,42.4 C9.492,42.4 0,32.908 0,21.2 C0,9.492 9.492,0 21.2,0 C32.909,0 42.4,9.492 42.4,21.2 Z",
    id: "Stroke-1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8425,12.7266 C17.8425,15.5406 15.5615,17.8206 12.7485,17.8206 C9.9345,17.8206 7.6535,15.5406 7.6535,12.7266 C7.6535,9.9126 9.9345,7.6326 12.7485,7.6326 C15.5615,7.6326 17.8425,9.9126 17.8425,12.7266 Z",
    id: "Stroke-3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7469,12.7266 C34.7469,15.5406 32.4659,17.8206 29.6529,17.8206 C26.8389,17.8206 24.5579,15.5406 24.5579,12.7266 C24.5579,9.9126 26.8389,7.6326 29.6529,7.6326 C32.4659,7.6326 34.7469,9.9126 34.7469,12.7266 Z",
    id: "Stroke-5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2947,32.6414 C26.2947,35.4554 24.0137,37.7354 21.2007,37.7354 C18.3867,37.7354 16.1057,35.4554 16.1057,32.6414 C16.1057,29.8274 18.3867,27.5474 21.2007,27.5474 C24.0137,27.5474 26.2947,29.8274 26.2947,32.6414 Z",
    id: "Stroke-7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3258,25.2312 C35.3258,26.7662 34.0818,28.0102 32.5468,28.0102 C31.0118,28.0102 29.7678,26.7662 29.7678,25.2312 C29.7678,23.6962 31.0118,22.4522 32.5468,22.4522 C34.0818,22.4522 35.3258,23.6962 35.3258,25.2312 Z",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6322,25.2312 C12.6322,26.7662 11.3882,28.0102 9.8532,28.0102 C8.3192,28.0102 7.0742,26.7662 7.0742,25.2312 C7.0742,23.6962 8.3192,22.4522 9.8532,22.4522 C11.3882,22.4522 12.6322,23.6962 12.6322,25.2312 Z",
    id: "Stroke-11"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ1772);
export default __webpack_public_path__ + "static/media/J1772.aca474fb78321ba65690a79996196a3e.svg";
export { ForwardRef as ReactComponent };